"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _dropdown = require("../dropdown");

var _icon = _interopRequireDefault(require("../../atoms/icon"));

var _tokens = require("../../../tokens");

var _utilities = require("../../_utils/utilities");

var _fontIcon = _interopRequireWildcard(require("../../atoms/font-icon"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n        ", ":first-child, ", ":first-child  {\n          margin-left: 8px;\n        }\n      "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  height: ", ";\n  max-width: ", ";\n  min-width: ", ";\n  width: ", ";\n  box-sizing: border-box;\n  text-transform: ", ";\n  text-align: center;\n  letter-spacing: 0.3px;\n  font-size: 13px;\n  font-weight: ", ";\n  background: ", ";\n  border: 1px solid;\n  border-color: ", ";\n  border-radius: ", ";\n\n  color: ", ";\n\n  padding: 0 ", ";\n\n  opacity: ", ";\n  cursor: ", ";\n  pointer-events: ", ";\n  transition: border-color ", ",\n    background ", ";\n\n  span {\n    margin-left: ", ";\n    margin-right: 8px;\n  }\n\n  ", " {\n    margin: 0 0 0 8px;\n  }\n  ", ";\n\n  ", " {\n    position: relative;\n    top: 0px;\n    color: ", ";\n  }\n  ", ":last-child {\n    margin-right: 8px;\n    margin-left: auto;\n  }\n\n  &:hover {\n    color: ", ";\n    background: ", ";\n    border-color: ", ";\n  }\n\n  &:focus {\n    background: ", ";\n    color: ", ";\n    border-color: ", ";\n    outline: none;\n    pointer-events: none;\n  }\n\n  &:active {\n    background: ", ";\n    color: ", ";\n    border-color: ", ";\n    outline: none;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var DropdownButton = function DropdownButton(props) {
  var content = [];
  var size = props.size || 16;

  if (props.icon) {
    var color = props.iconColor || (0, _dropdown.getStyles)(props).icon;

    if (_utilities.iconPattern.test(props.icon)) {
      content.push(_react["default"].createElement(_fontIcon["default"], {
        size: size,
        color: color
      }, props.icon));
    } else {
      content.push(_react["default"].createElement(_icon["default"], {
        key: "icon",
        size: size,
        name: props.icon,
        color: color
      }));
    }
  }

  var grouped = props.grouped;

  if (props.selectedLabel) {
    content.push(_react["default"].createElement(_dropdown.StyledContent, {
      key: "text",
      fullWidth: props.fullWidth,
      selected: true,
      grouped: grouped
    }, props.selectedLabel));
  } else {
    content.push(_react["default"].createElement(_dropdown.StyledContent, {
      key: "placeholder",
      fullWidth: props.fullWidth,
      placeholder: true,
      grouped: grouped
    }, props.placeholder));
  }

  content.push(_react["default"].createElement(_icon["default"], {
    key: "right-icon",
    size: 16,
    name: 'chevron-down',
    color: (0, _dropdown.getStyles)(props).icon
  }));
  return _react["default"].createElement(DropdownButton.Element, props, content);
};

DropdownButton.Element = _styledComponents["default"].button(_templateObject(), function (props) {
  return (0, _dropdown.getStyles)(props).height;
}, function (props) {
  return !props.fullWidth && '560px';
}, function (props) {
  return !props.noMinWidth ? (0, _dropdown.getStyles)(props).minWidth : '70px';
}, function (props) {
  return props.fullWidth && '100%';
}, function (props) {
  return props.textTransform;
}, _tokens.fonts.weight.medium, function (props) {
  return (0, _dropdown.getStyles)(props).background;
}, function (props) {
  return props.borderOnHoverOnly ? 'transparent' : (0, _dropdown.getStyles)(props).border;
}, function (props) {
  if (props.renderType === 'button') {
    return (0, _dropdown.getStyles)(props).radius;
  }

  return '25px';
}, function (props) {
  return (0, _dropdown.getStyles)(props).text;
}, function (props) {
  return (0, _dropdown.getStyles)(props).padding;
}, function (props) {
  return props.disabled ? 0.5 : 1;
}, function (props) {
  return props.disabled ? 'not-allowed' : 'pointer';
}, function (props) {
  return props.disabled ? 'none' : null;
}, _tokens.misc.animationDuration, _tokens.misc.animationDuration, function (props) {
  return props.icon ? _tokens.spacing.xsmall : _tokens.spacing.small;
}, _fontIcon.StyledIcon, function (props) {
  if (props.icon) return (0, _styledComponents.css)(_templateObject2(), _icon["default"].Element, _fontIcon.StyledIcon);
}, _icon["default"].Element, function (props) {
  return (0, _dropdown.getStyles)(props).text;
}, _icon["default"].Element, function (props) {
  return (0, _dropdown.getStyles)(props).hoverText || (0, _dropdown.getStyles)(props).text;
}, function (props) {
  return (0, _dropdown.getStyles)(props).hoverBackground;
}, function (props) {
  return (0, _dropdown.getStyles)(props).hoverBorder;
}, function (props) {
  return (0, _dropdown.getStyles)(props).focusBackground;
}, function (props) {
  return (0, _dropdown.getStyles)(props).hoverText || (0, _dropdown.getStyles)(props).text;
}, function (props) {
  return (0, _dropdown.getStyles)(props).focusBorder;
}, function (props) {
  return (0, _dropdown.getStyles)(props).activeBackground;
}, function (props) {
  return (0, _dropdown.getStyles)(props).hoverText || (0, _dropdown.getStyles)(props).text;
}, function (props) {
  return (0, _dropdown.getStyles)(props).activeBorder;
});
var _default = DropdownButton;
exports["default"] = _default;